import type { CSSProperties } from "react";

export type PopupWidth = "anchor" | "content" | (string & {});

export function popupWidthStyle(
  width: PopupWidth = "anchor",
): CSSProperties | undefined {
  if (width === "anchor") {
    return undefined;
  }

  return {
    width: width === "content" ? "max-content" : width,
    minWidth: "var(--anchor-width)",
    maxWidth: "var(--available-width)",
  };
}
